import { EvtHeader } from "components/header";
import React from "react";
import { useParams } from "react-router-dom";
import SkillsForm from "../form";

const UpdateSkill = () => {
  const { skillId } = useParams();

  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Update Department" />
      <div className="p-6 max-w-2xl">
        <SkillsForm skillId={skillId} />
      </div>
    </div>
  );
};

export default UpdateSkill;
